import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import sortBy from 'lodash/sortBy';

import HistoryTable from './history_table/HistoryTable';

import startCase from 'lodash/startCase';

import { Typography, Card, Divider } from 'antd';
import { ApplicationUIContext, helpers } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../ApplicationOverview';

const { WIDE_CARD_WIDTH } = helpers;

const { Title } = Typography;

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;

  > .ant-typography {
    margin: 0;
  }
`;

const History = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const { audits, events } = useContext(CurrentApplicationContext);

  const auditData = useMemo(() => {
    const filterAudits = (a) => {
      return a.action !== 'create';
    };

    const renderChanges = (a) => {
      return Object.entries(a.audited_changes).map(([key, changes]) => {
        return {
          humanField: startCase(key),
          changed_from: changes[0],
          changed_to: changes[1],
        };
      });
    };

    return audits.filter(filterAudits).map((audit) => {
      return {
        key: audit.id,
        created_at: audit.created_at,
        action_name: audit.action,
        audited_changes: renderChanges(audit),
        user_email: audit.user?.email,
        remote_address: '',
      };
    });
  }, [audits]);

  const eventData = useMemo(() => {
    return events.map((event) => {
      return {
        key: event.id,
        created_at: event.created_at,
        action_name: event.event_verbiage,
        user_email: event.created_by?.email,
        remote_address: '',
      };
    });
  }, [events]);

  const dataSource = useMemo(() => {
    return sortBy(auditData.concat(eventData), (obj) => {
      return obj.created_at;
    }).reverse();
  }, [eventData, auditData]);

  return (
    <Card style={{ maxWidth: WIDE_CARD_WIDTH }}>
      <StyledHeader>
        <Title level={isMobile ? 3 : 4}>
          {getTranslatedString('landlordPortal.applicationManagement.applicationOverview.history')}
        </Title>
      </StyledHeader>
      <Divider />
      <HistoryTable dataSource={dataSource} />
    </Card>
  );
};

export default History;
